import React from 'react'
import backgroundImg from '../ui/Backdrop_home.png'

import './notFound.css'

const NotFound = () => {
  return (

    <>

      <div id='backdropContainer'>

        <img src={backgroundImg} alt="Ein Bild mit Kaleidoskopmuster" id='Backdrop_notFound' />
      </div>


      <div className='block'>
      <div className='title'>404 - Nicht Verfügbar</div>

      </div>
      
    </>

  )
}

export default NotFound